import * as React from "react";
import { useScrollIntoView } from "@grandvisionhq/utils";
/* empty css                    */
const ScrollIntoView = ({ children }) => {
  const { elementRef, triggerScroll } = useScrollIntoView();
  React.useEffect(() => {
    triggerScroll();
  }, [triggerScroll]);
  return /* @__PURE__ */ React.createElement("div", { className: "scroll-into-view", "data-t": "scroll-into-view", ref: elementRef }, children);
};
export {
  ScrollIntoView
};
//# sourceMappingURL=ScrollIntoView.js.map
